module.exports = __webpack_public_path__ + "img/banner2_sound.768e5dff.png";